export default {
  API_ENDPOINT: "https://frozen-peak-86835.herokuapp.com/api",
  TOKEN_KEY: process.env.REACT_APP_API_KEY
  // TOKEN_KEY: "blogful-client-auth-token"
};
